import './search.scss';

class Search {
    constructor (element) {
        this.$search = element;
        this.$searchForm = this.$search.querySelector('[data-search="form"]');
        this.$paginationSelect = this.$search.querySelector('[data-search-overview="paginationselect"]');
        this.$showResults = this.$searchForm.querySelectorAll('[data-search="showresults"]');
        this.$categories = this.$searchForm.querySelectorAll('[data-search="category"]');
        this.$activeResultCount = this.$searchForm.querySelector('[data-search="showresults"]:checked');
        this.$activeCategory = this.$searchForm.querySelector('[data-search="category"]:checked');
        this.$filterReset = this.$searchForm.querySelector('[data-filter-reset]');
        this.$searchInput = this.$searchForm.querySelector('#search_input');

        this.initialize();
    }

    initialize () {
        this.setEvents();
    }

    resetCurrentPage () {
        if (this.$paginationSelect) {
            this.$paginationSelect.querySelector('option').value = 1;
        }
    }

    setEvents () {
        if (this.$showResults.length > 1) {
            this.$showResults.forEach((resultcount) => {
                resultcount.addEventListener('change', () => {
                    if (this.$activeResultCount.value !== resultcount.value) {
                        this.$searchForm.submit();
                    }
                });
            });
        }

        if (this.$categories.length > 1) {
            this.$categories.forEach((category) => {
                category.addEventListener('change', () => {
                    if (this.$activeCategory) {
                        if (this.$activeCategory.value !== category.value) {
                            this.resetCurrentPage();
                            this.$searchForm.submit();
                        }
                    } else {
                        this.resetCurrentPage();
                        this.$searchForm.submit();
                    }
                });
            });
        }

        if (this.$paginationSelect) {
            this.$paginationSelect.addEventListener('change', () => {
                if (this.$searchForm) {
                    this.$searchForm.submit();
                }
            });
        }

        if (this.$searchInput) {
            this.$searchInput.addEventListener('input', () => {
                this.resetCurrentPage();
            });
        }

        if (this.$filterReset) {
            this.$filterReset.addEventListener('change', () => {
                this.$filterReset.disabled = true;
                this.resetCurrentPage();
                this.$searchForm.submit();
            });
        }
    }
}

export { Search };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$search = $context.querySelectorAll('[data-search="root"]');
        for (let i = 0; i < $$search.length; i++) {
            const $search = $$search[i];
            $search.API = new Search($search);
        }
    }
});
